import ReactDOM from 'react-dom';
import { Modal, Tab, Tabs } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import e from '../style.module.css';
import TableRender from 'components/common/TableRender/TableRender';
import React, { useEffect, useState } from 'react';
import apiService from 'Services/apiService';
import { formatDate } from 'Utils/Fn/DateParser';
import { SkeTable } from 'components/common/Skeleton/SkeTable';


function ModalBillingTabs({ show, mData, handleClose }: IModal) {
  const [billingCxC, setBillingCxC] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [billingAgre, setBillingAgre] = useState<any[]>([]);
  const [loadingAgre, setLoadingAgre] = useState(true);
  

  const B_CxC_ROWS = [
    {label: 'Código Recibo', key: 'codRecibo'},
    {label: 'Fecha', key: 'date'},
    {label: 'Monto', key: 'amount', class: 'text-right', classBody: 'text-right'},
    {label: 'Moneda', key: 'moneda'},
    {label: 'Notas', key: 'notas'},
    {label: 'Nro. Póliza', key: 'nroPoliza'},
    {label: 'Documento', key: 'nroDocumento'},
    {label: 'Tipo', key: 'tipo'}
  ];
  const B_AGREEMENT_ROWS = [
    {label: 'Acuerdo Nro.', key: 'codAcuerdos'},
    {label: 'Descripción', key: 'notas'},
    {label: 'Monto', key: 'amount', class: 'text-right', classBody: 'text-right'},
    {label: 'Fecha Vcto.', key: 'due_date'},
    {label: 'Nro. Póliza', key: 'nroPoliza', style: {width: '170px'}},
    {label: 'Estado', key: 'estado'}
  ];

  useEffect(() => {
    if (!mData) return
    apiService({
      name: 'getBillingCxCCop',
      queryParams: { _codigoFactura: mData.codCuentasxCobrar },
      onSuccess: ({response}) => {
        const resp = response.map((data: any) => (
          {...data,
            id: data.codigo,
            date: formatDate(new Date(data.fecha)),
            amount: `$${data.monto}`
          }
        ));
        setBillingCxC(resp);
      },
      onError: (error) => {
        console.error('Error:', error);
      },
      onFinally() {
        setLoading(false);
      }
    });
    apiService({
      name: 'getBillingPayAgreCop',
      queryParams: { _codigoFactura: mData.codCuentasxCobrar },
      onSuccess: ({response}) => {
        const resp = response.map((data: any) => (
          {...data,
            id: data.codigo,
            due_date: formatDate(new Date(data.fecVencimiento)),
            amount: `$${data.monto}`
          }
        ));
        setBillingAgre(resp);
      },
      onError: (error) => {
        console.error('Error:', error);
      },
      onFinally() {
        setLoadingAgre(false);
      }
    });
  }, [mData]);

  return (
    <>
    <Modal
      show={show}
      onHide={ ()=> {
        setLoading(true)
        setLoadingAgre(true)
        setBillingAgre([])
        setBillingCxC([])
        handleClose()
      }}
      dialogClassName="modal-xl"
      aria-labelledby="example-custom-modal-styling-title"
      className={e['modal-billing']}
    >
      
      <Modal.Header closeButton>
        <Modal.Title>
          <span className={e.modal_header}>Detalles CxC <small>#{mData?.codCuentasxCobrar}</small></span>
        </Modal.Title>
      </Modal.Header>

      <Modal.Body className={e.modal_body}>
        <section className={e.section_modal}>
          <Tabs
            defaultActiveKey="receipts"
            id="tab-BillingList"
            className={`mb-3 ${e['tab-modal']}`}
          >
            <Tab eventKey="receipts" title="Recibos">
            {loading ? (
              <SkeTable
                col={8}
                row={5}
                className="pt-1"
              />
            ) : (
              <React.Fragment key={mData?.doc_num}>
                <div className={e['table-container']}>
                  <TableRender
                    id="BillinReceiptsTable"
                    schema={B_CxC_ROWS}
                    rows={billingCxC}
                  />
                </div>
            </React.Fragment>
            )}
            
            </Tab>
            <Tab eventKey="agreement" title="Acuerdo de pago">
            {loadingAgre ? (
              <SkeTable
                col={6}
                row={10}
                className="pt-1"
              />
            ) : (
              <React.Fragment key={`agreementT_${mData?.doc_num}`}>
                <div className={e['table-container']}>
                  <TableRender
                    id="BillinAgreementTable"
                    schema={B_AGREEMENT_ROWS}
                    rows={billingAgre}
                  />
                </div>
              </React.Fragment>
              )}              
            </Tab>
          </Tabs>
        </section>     
      </Modal.Body>

      <Modal.Footer>
        <Button variant='secondary' onClick={() => {
          setLoading(true)
          setLoadingAgre(true)
          setBillingAgre([])
          setBillingCxC([])
          handleClose()
        }}>
          Close
        </Button>
      </Modal.Footer>

    </Modal>
  </>
  )
}


export default function ModalBilling ({ show, handleClose, mData }: IModal) {

  const modalRoot = document.getElementById('modal-root') as HTMLElement;

  return ReactDOM.createPortal(
  <ModalBillingTabs
    show={show} 
    handleClose={handleClose} 
    mData={mData} 
  />, 
  modalRoot)

}


interface IModal{
  show: boolean;
  mData: any;
  handleClose: () => void;
}